import React, { useEffect, useState } from 'react';
import Pagination from '../../../components/pagination';
import { searchTenantCosts, deleteTenantCost } from '../../../api/sportaloka-client';
import FilterModal from '../components/FilterModal';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

function TenantCostsTable({ onFilterLengthChanged }) {
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10,
    sort_field: 'updated_at',
    sort_value: 'desc',
    description: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const handlePageChange = (page) => {
    setPaginationOptions({ ...paginationOptions, page });
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        description: paginationOptions.description
      }).toString();
      const response = await searchTenantCosts(query);
      const responseData = response.data.data.data;
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleFilter = (description) => {
    const filterLength = description ? 1 : 0;
    setPaginationOptions({ ...paginationOptions, description });
    onFilterLengthChanged(filterLength);
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Apakah anda tetap ingin menghapus data biaya ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Lanjut',
      cancelButtonText: 'Batal'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          setData([]);
          await deleteTenantCost(id);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: `Biaya berhasil dihapus`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: `Periksa koneksi internet anda`,
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        }
      }
    });
  };

  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <FilterModal onFilter={handleFilter} />
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th className="text-left">Deskripsi</th>
            <th className="text-center">Harga</th>
            <th className="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td>{row.description}</td>
              <td className="text-center">{row.amount}</td>
              <td className="text-center pe-0">
                <Link
                  to={`/tenant-costs/detail/${row.id}`}
                  className="fw-500 text-blue-1 btn btn-primary text-white btn-sm border-blue-1 mr-10">
                  Ubah
                </Link>
                <button
                  onClick={() => handleDelete(row.id)}
                  className="fw-500 text-blue-1 btn btn-danger text-white btn-sm">
                  Hapus
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={paginationOptions.page}
        totalRows={totalRows}
        rowsPerPage={paginationOptions.limit}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default TenantCostsTable;
